/**
 * Created by n.rusev on 13/3/2019.
 */
import React from "react";
import documentedProps from "./documentation/RowDocumentedProps";

export default class Row extends React.Component {
    render() {
        return <div className="tq-row">{this.props.children}</div>;
    }
}

Row.displayName = "Row";

Row.documentedProps = documentedProps;
